import React, { useEffect } from "react";
import Logo from "../../assets/images/dashboardLogo.svg";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { GoBell } from "react-icons/go";
import { CiEdit } from "react-icons/ci";
import { IoMdLogOut } from "react-icons/io";
import { Chip, Divider, ListItemButton, Stack } from "@mui/material";
import Bus from "../../event/bus";
import LogoutModal from "../Dashboard/Modals/LogoutModal";
import { useNavigate } from "react-router-dom";
import { listItemButtonStyle, navLinkStyle } from "../Dashboard/Tables/Styles";

const Sidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobile, setMobile] = useState(false);

  const removeSidebar = () => {
    setSidebarOpen(false);
    setMobile(false);
  };

  const [openLogout, setOpenLogout] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleCustomEvent = () => {
      setMobile(!mobile);
      setSidebarOpen(!sidebarOpen);
    };

    Bus.on("toggle-sidebar", handleCustomEvent);

    return () => {
      Bus.off("toggle-sidebar", handleCustomEvent);
    };
  }, [mobile, sidebarOpen]);

  const handleOpenLogout = (e) => {
    setOpenLogout(true);
  };

  const handleCloseLogout = () => {
    setOpenLogout(false);
  };

  const handleActionLogout = () => {
    setOpenLogout(false);
    setTimeout(() => {
      navigate("/auth/login");
    }, 500);
  };

  return (
    <div>
      {mobile && (
        <div
          className="absolute inset-0 z-50  backdrop-blur-sm"
          onClick={removeSidebar}
        ></div>
      )}
      <div
        className={`${
          sidebarOpen ? "w-40 z-50 absolute transition-width" : "hidden z-10"
        } h-screen sm:block min-w-[17rem] bg-[#fff] text-white overflow-y-hidden`}
      >
        <div
          className="flex flex-col h-screen overflow-y-auto justify-between pt-6 p-6 mt-1 "
          id="sidebar"
        >
          <nav className="flex flex-col justify-between h-[100vh]">
            <ul>
              <li className="mb-12">
                <NavLink
                  to="/candidate/dashboard"
                  className="flex  gap-4 items-center hover:text-[#1E87FF] !font-sans text-sm leading-4 text-[#292727] font-bold"
                >
                  <img src={Logo} alt="Logo" />
                </NavLink>
              </li>
              <li className="mb-4">
                <NavLink
                  style={navLinkStyle}
                  to="/candidate/dashboard/"
                  className="flex gap-4 items-center  hover:text-[#1E87FF]   hover:font-bold "
                >
                  <RxDashboard className="sidebar-icon" />
                  <span>Dashboard</span>
                </NavLink>
              </li>
              <li className="mb-8">
                <NavLink
                  style={navLinkStyle}
                  to="/candidate/dashboard/notifications"
                  className="flex gap-4 !justify-between hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <ListItemButton
                    className="flex gap-4 pl-0 !justify-between "
                    sx={{ ...listItemButtonStyle, pl: 0, mt: 0 }}
                  >
                    <Stack spacing={2} direction="row">
                      <GoBell className="sidebar-icon" />
                      <span className="mr-4">Notification</span>
                    </Stack>

                    <Chip
                      label="3"
                      size="small"
                      sx={{
                        background: "#EDF5FF",
                        color: "#1E87FF",
                        padding: "2px, 10px, 2px, 10px",
                        height: "19px",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 600,
                        lineHeight: "14.29px",
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              </li>
              <Divider />

              <li className="mt-8 mb-8">
                <NavLink
                  style={navLinkStyle}
                  to="/candidate/dashboard/doc-signature"
                  className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <ListItemButton
                    className="flex gap-4 pl-0 !justify-between "
                    sx={{ ...listItemButtonStyle, pl: 0, mt: 0 }}
                  >
                    <Stack spacing={2} direction="row">
                      <CiEdit className="sidebar-icon" />
                      <span>DocSignr</span>
                    </Stack>
                    <Chip
                      label="10"
                      size="small"
                      className="ml-4"
                      sx={{
                        background: "#EDF5FF",
                        color: "#1E87FF",
                        padding: "2px, 10px, 2px, 10px",
                        height: "19px",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 600,
                        lineHeight: "14.29px",
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              </li>
            </ul>

            <ul>
              <Divider sx={{ mb: 5 }} />
              <li className="mt-8 md:mt-0 mb-8">
                <NavLink
                  style={navLinkStyle}
                  to="/candidate/dashboard/profile"
                  className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="sidebar-icon"
                  >
                    <path
                      d="M8.10671 7.74536C8.08671 7.74536 8.07337 7.74536 8.05337 7.74536C8.02004 7.7387 7.97337 7.7387 7.93337 7.74536C6.00004 7.68536 4.54004 6.16536 4.54004 4.29203C4.54004 2.38536 6.09337 0.832031 8.00004 0.832031C9.90671 0.832031 11.46 2.38536 11.46 4.29203C11.4534 6.16536 9.98671 7.68536 8.12671 7.74536C8.12004 7.74536 8.11337 7.74536 8.10671 7.74536ZM8.00004 1.83203C6.64671 1.83203 5.54004 2.9387 5.54004 4.29203C5.54004 5.62536 6.58004 6.6987 7.90671 6.74536C7.94004 6.7387 8.03337 6.7387 8.12004 6.74536C9.42671 6.68536 10.4534 5.61203 10.46 4.29203C10.46 2.9387 9.35337 1.83203 8.00004 1.83203Z"
                      fill="currentColor"
                    />
                    <path
                      d="M8.11307 15.0346C6.80641 15.0346 5.49307 14.7013 4.49974 14.0346C3.57307 13.4213 3.06641 12.5813 3.06641 11.668C3.06641 10.7546 3.57307 9.90797 4.49974 9.28797C6.49974 7.9613 9.73974 7.9613 11.7264 9.28797C12.6464 9.9013 13.1597 10.7413 13.1597 11.6546C13.1597 12.568 12.6531 13.4146 11.7264 14.0346C10.7264 14.7013 9.41974 15.0346 8.11307 15.0346ZM5.05307 10.128C4.41307 10.5546 4.06641 11.1013 4.06641 11.6746C4.06641 12.2413 4.41974 12.788 5.05307 13.208C6.71307 14.3213 9.51307 14.3213 11.1731 13.208C11.8131 12.7813 12.1597 12.2346 12.1597 11.6613C12.1597 11.0946 11.8064 10.548 11.1731 10.128C9.51307 9.0213 6.71307 9.0213 5.05307 10.128Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span>Profile</span>
                </NavLink>
              </li>

              <li className="pb-8" onClick={handleOpenLogout}>
                <div className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold">
                  <IoMdLogOut className="sidebar-icon" />
                  <span>Logout</span>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {openLogout && (
        <LogoutModal
          handleLogout={handleActionLogout}
          onClose={handleCloseLogout}
        />
      )}
    </div>
  );
};

export default Sidebar;
